const enumeratorMyFavorites = [
  ['anoFabricacao', 'manufacturingYear'],
  ['anoModelo', 'yearModel'],
  ['cambioId', 'gearId'],
  ['cambioNome', 'gearName'],
  ['cidadeId', 'cityId'],
  ['cidadeNome', 'cityName'],
  ['combustivelId', 'fuelId'],
  ['combustivelNome', 'fuelName'],
  ['corId', 'colorId'],
  ['corNome', 'colorName'],
  ['cupom', 'coupon'],
  ['id', 'id'],
  ['imagemAnuncio', 'images'],
  ['ordem', 'order'],
  ['itensDescricao', 'descriptionItems'],
  ['km', 'mileage'],
  ['link', 'link'],
  ['marcaId', 'brandId'],
  ['marcaNome', 'brandName'],
  ['modeloId', 'modelId'],
  ['modeloNome', 'modelName'],
  ['opcionais', 'optionals'],
  ['nome', 'name'],
  ['placa', 'plate'],
  ['planoId', 'planId'],
  ['planoNome', 'planName'],
  ['portas', 'doors'],
  ['statusId', 'statusId'],
  ['statusNome', 'statusName'],
  ['texto', 'text'],
  ['tipoAnuncianteId', 'listingAgentId'],
  ['tipoAnuncianteNome', 'listingAgentName'],
  ['ufId', 'stateId'],
  ['ufNome', 'stateName'],
  ['valorVenda', 'price'],
  ['versaoId', 'versionId'],
  ['versaoNome', 'versionName']
];

export const locateMyFavoritesIn = Object.fromEntries(enumeratorMyFavorites);
export const locateMyFavoritesOut = Object.fromEntries(
  enumeratorMyFavorites.map(elem => [elem[1], elem[0]])
);
